import * as $ from 'jquery';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommonService } from '../../../../services/common/common.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import {
  AccountError,
  AccountSearchFilter,
  dashboradDDL,
} from '../../../../models/GrowerListing';
import { NgForm } from '@angular/forms';
import { SOTService } from '../../../../services/seed/sot/sot.service';
import { eventDetail } from '../../../../models/AccountDetailsVM';
import { StockTransferSelectAccountSliderModelService } from './sot-select-account.component-slider-model.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-sot-select-account',
  templateUrl: './sot-select-account.component.html',
  styleUrls: ['./sot-select-account.component.scss'],
})
export class StockTransferSelectAccountComponent implements OnInit, OnDestroy, OnChanges {
  private subscription = new Array<Subscription>();

  // header company code and crop year
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  stateDS: any[];
  // drop down variables for account and state
  accountSearchData: any[] = [];
  accountDataCount: number;
  headerList: any[];
  filterArray: any[];
  growerDS: any[];
  apiResult: any[];
  // used as a model for search account form
  brwModel = new AccountSearchFilter();
  // used as a error model for search account form
  brwErrorModel = new AccountError();
  enableErrorMsg: any;
  ErrorMessage: any;
  @Input() FromAccountDS: any = [];
  @Output()
  AccountSelected: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  constructor(
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private stockTransferServicee: SOTService,
    private loaderService: LoaderService,
    private stockTransferSelectAccountSliderModelService: StockTransferSelectAccountSliderModelService
  ) {
    // Set the default value for crop year
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(
        this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)
      );
    }

    this.headerList = [
      {
        headertxt: 'Account Name',
        columnfield: 'accountName',
        className: 'mat-header-cell accountSotName selectAcHeader',
      },
      {
        headertxt: 'Account#',
        columnfield: 'accountNumber',
        className: 'mat-header-cell  sotZip selectAcHeader',
      },
      {
        headertxt: 'Address',
        columnfield: 'address1',
        className: 'mat-header-cell sotAddress selectAcHeader',
      },
      {
        headertxt: 'City',
        columnfield: 'city',
        className: 'mat-header-cell sotCity selectAcHeader',
      },
      {
        headertxt: 'State',
        columnfield: 'state',
        className: 'mat-header-cell accountSotState selectAcHeader',
      },
      {
        headertxt: 'Zip',
        columnfield: 'zipCode',
        className: 'mat-header-cell sotZip selectAcHeader',
      },
      {
        headertxt: 'Phone',
        columnfield: 'primaryPhoneNumber',
        className: 'mat-header-cell sotPhone selectAcHeader',
      },
    ];

    // set properties of Model

    this.brwModel.BusinessName = '';
    this.brwModel.City = '';
    this.brwModel.State = null;
  }

  clearFilter() {
    this.brwModel.BusinessName = '';
    this.brwModel.City = '';
    this.brwModel.State = null;
  }

  ngOnInit(): void {
    this.filterArray = [
      { label: 'Account Name', column: 'accountName' },
      { label: 'Account Number', column: 'account' },
      { label: 'Address', column: 'address' },
      { label: 'City', column: 'city' },
      { label: 'State / Province', column: 'state' },
      { label: 'Zip', column: 'zip' },
      { label: 'Phone', column: 'phoneNo' },
    ];

    this.getDropDownData();
  }

  ngOnChanges() {
    this.clearFilter();
  }

  convertToPass(dataList: any[]) {
    // declare and initialize an array
    const convertedList = [];

    // Null check
    if (dataList != null) {
      // lop through data
      dataList.forEach((x) => {
        // Null check
        if (x) {
          convertedList.push({
            accountName: x.accountName,
            accountNameCityState: x.accountNameCityState,
            accountNumber: x.accountNumber,
            accountType: x.accountType,
            address1: x.address1,
            state: x.state,
            billingAddressType: x.billingAddressType,
            city: x.city,
            primaryPhoneNumber: x.primaryPhoneNumber,
            zipCode: x.zipCode,
            parentNumber: x.parentNumber,
            country: x.country,
          });
        }
      });
    }
    return convertedList;
  }

  filterGrid(e: any) {
    // e : contain filter data and Null check
    if (e) {
      // get all values in local variables
      const phoneNo = e.phoneNo;
      const name = e.accountName;
      const address = e.address;
      const state = e.state;
      const city = e.city;
      const zip = e.zip;
      const accountNo = e.accountNo;

      // search data on Api data get the result
      const result = this.apiResult.filter((x) =>
      // check row values on filter data
      (
        (name
          ? x.accountName &&
          x.accountName.toLowerCase().indexOf(name.toLowerCase()) !== -1
          : true) &&
        (address
          ? x.address1 &&
          x.address1.toLowerCase().indexOf(address.toLowerCase()) !== -1
          : true) &&
        (phoneNo
          ? x.primaryPhoneNumber &&
          x.primaryPhoneNumber
            .toLowerCase()
            .indexOf(phoneNo.toLowerCase()) !== -1
          : true) &&
        (city
          ? x.city && x.city.toLowerCase().indexOf(city.toLowerCase()) !== -1
          : true) &&
        (zip
          ? x.zipCode &&
          x.zipCode.toLowerCase().indexOf(zip.toLowerCase()) !== -1
          : true) &&
        (accountNo
          ? x.accountNumber && x.accountNumber.toString() == accountNo
          : true) &&
        (state
          ? x.state &&
          x.state.toLowerCase().indexOf(state.toLowerCase()) !== -1
          : true)
      )
      );

      // converted data into Grower Name and Phone no column and the assign it to grower Data source
      this.growerDS = this.convertToPass(result);
    } else {
      this.growerDS = this.convertToPass(this.apiResult);
    }
  }

  SelectAccount(e: any) {
    this.stockTransferSelectAccountSliderModelService.setData<
      StockTransferSelectAccountSliderModelService[]
    >(e.rowData);
    this.stockTransferSelectAccountSliderModelService.stockTransferClose();
  }

  // Added validation to check length of fields >2
  lengthValidation(field: string, value: string) {
    if (value.length < 2 && value != '') {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Please enter a minimum of 2 characters in a field';

      switch (field) {
        case 'City':
          this.brwErrorModel.City = true;
          break;
        case 'BusinessName':
          this.brwErrorModel.BusinessName = true;
          break;
      }
    } else {
      // set displayed message false
      this.enableErrorMsg = false;
      this.brwErrorModel.City = false;
      this.brwErrorModel.BusinessName = false;
    }
  }

  // Validation search criteria
  validateSearchInput() {
    let result = false;

    // set validation pass true
    if (
      (this.brwModel.BusinessName && this.brwModel.BusinessName.trim() != '') ||
      (this.brwModel.City &&
        this.brwModel.City.trim() != '' &&
        this.brwModel.State != null &&
        this.brwModel.State &&
        this.brwModel.State.trim() != '')
    ) {
      this.enableErrorMsg = false;
      this.ErrorMessage = '';
      result = false;
      this.setError(false, false, false);
    } else {
      if (
        (this.brwModel.City == '' &&
          this.brwModel.State != null &&
          this.brwModel.State &&
          this.brwModel.State != '') ||
        (this.brwModel.City != '' && !this.brwModel.State)
      ) {
        this.enableErrorMsg = true;
        this.ErrorMessage =
          'City and State is required when searching by City or State';
        result = true;

        this.setError(false, true, true);
      } else if (this.brwModel.BusinessName == '') {
        this.enableErrorMsg = true;
        this.ErrorMessage =
          'Account Name is required when searching by Account Name';
        result = true;
        // this.setError(true, true, false, false, false, false, false, false);
        this.setError(true, false, false);
      }
    }
    return result;
  }

  setError(BusinessName: boolean, City: boolean, State: boolean) {
    this.brwErrorModel.BusinessName = BusinessName;
    this.brwErrorModel.City = City;
    this.brwErrorModel.State = State;
  }

  searchAccount(searchAccountForm: NgForm) {
    this.loaderService.setLoaderStatus(true);
    if (
      this.brwModel.BusinessName == '' &&
      this.brwModel.City == '' &&
      this.brwModel.State == null
    ) {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Add more search parameter';
      return false;
    } else {
      this.enableErrorMsg = false;
      this.ErrorMessage = '';
    }

    if (this.brwErrorModel.BusinessName || this.brwErrorModel.City) {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Minimum 2 character required for search';
      return false;
    }

    // Api search call

    if (this.brwModel) {
      const state = this.brwModel.State == null ? '' : this.brwModel.State;
      // set loader true
      // this.loaderService.setLoaderStatus(true);

      this.subscription.push(this.stockTransferServicee
        .getToccountList(
          this.brwModel.BusinessName,
          this.brwModel.City,
          state
        )
        .subscribe(
          (result) => {
            this.setGridResult(result);
            this.loaderService.setLoaderStatus(false);
          },
          (error) => {
            LolLoggerService.error(error);
            this.loaderService.setLoaderStatus(false);
          }
        ));
    }
  }

  setGridResult(result: any) {
    const fromAccountNo = this.stockTransferServicee.getSelectedAccountNo();
    const index = result.findIndex(function (o) {
      return o.accountNumber === fromAccountNo;
    });
    if (index !== -1) { result.splice(index, 1); }
    this.growerDS = result;
    this.apiResult = result;
  }

  // set Add product table height
  setAccInvProdTableHeight() {
    const tableHeight =
      window.innerHeight -
      $('.prod-top-sec').outerHeight() -
      $('.mat-tab-header').outerHeight() -
      $('.add-order-sec').outerHeight() -
      65;
    $('.sot-add-prod .accInvProdTable').css('max-height', tableHeight + 'px');
  }

  setcompInvProdTableHeight() {
    const tableHeight =
      window.innerHeight -
      $('.prod-top-sec').outerHeight() -
      $('.mat-tab-header').outerHeight() -
      $('.add-order-sec').outerHeight() -
      65;
    $('.sot-add-prod .compInvProdTable').css('max-height', tableHeight + 'px');
  }
  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
  }

  getDropDownData() {
    if (this.headerCompany && this.headerYear) {
      this.subscription.push(this.commonService
        .getFilterDDLData()
        .subscribe(
          (result) => {
            const data = result as dashboradDDL;
            this.accountSearchData = data.accounts as any[];

            // setting state drop down and remove All states value from list
            this.stateDS = data.states as any[];
            this.stateDS = this.stateDS.filter((x) => x.value != 'All States');
            this.accountDataCount = this.accountSearchData.length;
          },
          (error) => LolLoggerService.error(error)
        ));
    }
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
